import { IS_PROD } from 'utils/environment';

export function resolveAiAndBrandKitEnabled(isProduction: boolean, search: string): boolean {
	return !isProduction && new URLSearchParams(search).get('aiBrandKit') !== '0';
}

/** Release gate for unfinished Story chat and Brand Kit authoring. */
export const IS_AI_AND_BRAND_KIT_ENABLED = resolveAiAndBrandKitEnabled(
	IS_PROD,
	typeof window === 'undefined' ? '' : window.location.search
);
